<template>
    <v-dialog :value="value" max-width="1270px" persistent scrollable @keydown.esc.prevent="cancel">
        <v-card>
            <v-card-title class="text-h5 grey lighten-2">
                <span>
                    <span class="grey--text">{{ titleMutateAction }}: </span>
                    <span class="grey--text">{{ titleScheduleType }}{{ event.title ? ` - ` : '' }}</span>
                    <span v-if="event.title">{{ event.title }}</span>
                </span>
            </v-card-title>

            <v-card-text style="max-height: var(--usable-dialog-height)">
                <v-form v-model="valid">
                    <ScheduleEditDialogMainContainer :record="record" :event="event" />
                    <ScheduleEditDialogExceptions v-if="record.isRecurring" :record="record" />
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn text :disabled="saving" @click="cancel">{{ $t('cancel') }}</v-btn>
                <ActionBtn :disabled="!valid" :loading="saving" @click="save" @keydown.enter.prevent="save">
                    <KpIcon icon-cls="calendar" color="white" disabled-color="grey" left />
                    {{ $t('save_schedule') }}
                </ActionBtn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { Schedule } from '@/models/Schedule';
import { Event } from '@/models/Event';
import ScheduleEditDialogMainContainer from '@/components/schedule/EditDialogMainContainer.vue';
import ScheduleEditDialogExceptions from '@/components/schedule/EditDialogExceptions.vue';
import { errToStr } from '@/helpers/tools';

export default {
    name: 'ScheduleEditDialog',
    components: {
        ScheduleEditDialogMainContainer,
        ScheduleEditDialogExceptions,
    },

    props: {
        event: Event,
        record: Schedule,
        value: Boolean,
    },

    data() {
        return {
            saving: false,
            valid: true,
        };
    },

    computed: {
        titleMutateAction() {
            return this.record.$.id > 0 ? this.$t('edit') : this.$t('new');
        },
        titleScheduleType() {
            if (this.record.isSingle) {
                return this.$t('recurring_type_single');
            } else if (this.record.isRecurring) {
                return this.$t('recurring_type_recurring');
            } else {
                return '';
            }
        },
    },

    created() {
        this.Event = Event;
        this.Schedule = Schedule;
    },

    methods: {
        close() {
            this.$emit('input', false);
        },

        async save() {
            if (this.valid) {
                try {
                    this.saving = true;
                    await this.record.save();
                    this.$emit('saved', this.record);
                    this.close();
                } catch (e) {
                    this.$toast({ message: errToStr(e), color: 'error' });
                } finally {
                    this.saving = false;
                }
            }
        },

        cancel() {
            this.$emit('cancelled', this.record);
            this.close();
        },
    },
};
</script>
